import { api } from "@/builders/axios";
import { UTMEQuestions } from "@/builders/types/questions";

const get = function (id: number) {
  return api.get<UTMEQuestions>(`setup/questions/${id}`);
};

const put = function (id: number, data: UTMEQuestions) {
  return api.put(`/setup/questions/${id}`, data);
};

const patch = function (id: number, data: UTMEQuestions) {
  return api.patch(`/setup/questions/${id}`, data);
};

const del = function (id: number) {
  return api.delete(`/setup/questions/${id}`);
};

export const id = {
  get,
  put,
  patch,
  del,
};
